import { styled, buttonClasses, Button } from '@mui/material';

export const DashboardVariantV2GiverWidgetActionButton = styled(Button)(
  ({ theme }) => ({
    height: 41,

    [`& .${buttonClasses.startIcon}`]: {
      marginRight: theme.spacing(2),
    },

    [`& .${buttonClasses.endIcon}`]: {
      marginLeft: theme.spacing(2),
    },
  }),
);
